export default __webpack_public_path__ + "static/bis_cover-3960fab661f2807c66eefe9579bd7ce7.png";